/**
 * Text color types for form sections and fields
 */
export enum TextColorType {
  Default = 'default',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Info = 'info'
}

